/**
 * Copyright (c) 2023 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { useEffect, useState } from 'react';
import { useVideoContext } from '../../contexts/videoProvider/videoContext';

export default function useParticipantNetworkQualityLevel(participant: VideoProvider.IParticipant) {
  const { videoProvider } = useVideoContext();
  const [networkQualityLevel, setNetworkQualityLevel] = useState(participant.networkQualityLevel);

  useEffect(() => {
    // newNetworkQualityLevel values between 0 and 5
    // 0,1: bad | 2: below average | 3,4,5: good
    const handleNetworkQualityLevelChange = (newNetworkQualityLevel: number) =>
      setNetworkQualityLevel(newNetworkQualityLevel);

    setNetworkQualityLevel(participant.networkQualityLevel);

    videoProvider.onNetworkQualityLevelChanged(participant, handleNetworkQualityLevelChange);
    return () => {
      videoProvider.offNetworkQualityLevelChanged(participant, handleNetworkQualityLevelChange);
    };
  }, [participant]);

  return networkQualityLevel;
}
